<template>
  <div class="router-sidebar">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RouterSidebar'
}
</script>

<style lang="scss">
.router-sidebar {
  max-height: 100vh;
  overflow-y: scroll;
}
</style>
